import { render } from "./NewDriversPage.vue?vue&type=template&id=1af0c3ae&ts=true"
import script from "./NewDriversPage.vue?vue&type=script&lang=ts"
export * from "./NewDriversPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__